import { DEFAULT_PIXEL_SIZE } from 'modules/v2/foundation/spacing';
export const remToPx = (value, base) => {
    const baseValue = base || DEFAULT_PIXEL_SIZE;
    return value * baseValue;
};
